import { useMemo } from "react";
import { Flex, Text } from "@chakra-ui/layout";
import { PostagemItem } from "core/features/mural/typings";
import { Switch } from "@chakra-ui/switch";
import { showErrorAxios } from "infra/helpers/alerta";
import { useCallback } from "react";
import useTogglePostagemStatus from "core/features/mural/hooks/useTogglePostagemStatus";
import { Image } from "@chakra-ui/react";

function useListagemPostagensColumns({ onToogled }: { onToogled: () => void }) {
  const { isLoading, mutate: handleToggleStatus } = useTogglePostagemStatus();

  const _handleToggleStatus = useCallback(
    (id: string, checked: boolean) => {
      handleToggleStatus(
        { nextStatus: checked, id },
        {
          onError: (e) => {
            showErrorAxios(e, "Não foi possível alterar o status da postagem.");
          },
          onSuccess: () => {
            onToogled();
          },
        }
      );
    },
    [handleToggleStatus, onToogled]
  );

  return useMemo(() => {
    return [
      {
        title: "Foto",
        render: (original: PostagemItem) => (
          <Image
            htmlWidth={110}
            h="60px"
            objectFit="contain"
            src={original.imagem}
          />
        ),
      },
      {
        title: "Titulo",
        width: "50%",
        render: (original: PostagemItem) => (
          <Flex alignItems="center">
            <Text ml="8px">{original.titulo}</Text>
          </Flex>
        ),
      },
      {
        title: "Link",
        width: "30%",
        render: (original: PostagemItem) => (
          <Flex alignItems="center">
            <Text
              as="a"
              href={original.link}
              rel="noopener noreferrer"
              target="_blank"
              ml="8px"
            >
              {original.link}
            </Text>
          </Flex>
        ),
      },
      {
        title: "Status",
        width: "100px",
        onClick: () => {},
        render: (original: PostagemItem) => (
          <div>
            <Switch
              isDisabled={isLoading}
              onChange={() => {
                _handleToggleStatus(original.id, !original.ativo);
              }}
              isChecked={!!original.ativo}
            />
          </div>
        ),
      },
    ];
  }, [_handleToggleStatus, isLoading]);
}

export default useListagemPostagensColumns;
